import exp from "constants";
import React from "react";
import {motion} from 'framer-motion';


// BrandInfoBanner : 더리얼 브랜드의 가치 설명 UI


/**
 * 
 * @title : 
 * @pointText : 
 * @subtitles :
 */

interface BrandInfoBannerProps {
    className?: string;
    textColor?: string;
    imageURL: string;
    title: string;
    pointText?: string;
    subtitles: string[];
    descriptions: string[];
}



const BrandInfoBanner = ({ title, className, pointText, textColor, subtitles, descriptions, imageURL } : BrandInfoBannerProps) => {

    return (
    <section className={`${className} w-full h-[700px] desktop:h-[500px] tablet:h-[1000px] laptop:h-auto bg-white`}>
    <div className="brand-banner-container-main-container container mx-auto h-auto tablet:h-auto items-center px-4">
        <div className=" container h-[600px] desktop:h-[500px] laptop:h-[600px] tablet:h-[800px] grid grid-cols-1 desktop:grid-cols-2 gap-20 items-center max-w-screen-desktop mx-auto px-8 w-full ">

    <motion.div
        initial = {{ opacity : 0, y: 30}}
        whileInView={{ opacity: 1, y: 0}}
        viewport={{once: true, amount: 0.3}} 
        transition={{duration: 0.6, ease: 'easeOut'}}
        className="brand-banner-container-image-motion"
    >
    <div className="brand-banner-info-image">
        <img src={imageURL} className="
                desktop:h-[405px]"/>
     </div>
    </motion.div>
        <motion.div
            initial = {{ opacity: 0, y: 30}}
            whileInView={{ opacity:1, y: 0 }}
            viewport={{ once: true, amount: 0.3}}
            transition={{ duration: 0.8, delay: 0.4, ease: 'easeOut' }}
            className="brand-banner-container-text-motion"
        >
        <div className="brand-banner-container-main mx-auto text-left desktop:min-w-[768px] desktop:pr-40 desktop:pl-4 font-sans ">
            <h3 className={`brand-info-text text-xl desktop:text-5xl tablet:text-3xl laptop:text-4xl  font-bold whitespace-pre-line leading-tight ${textColor}`}>
                {title}
                <span className="brand-info-point-text text-emerald-400 text-4xl md:text-6xl font-bold"> {pointText}</span>
            </h3>
            <div className="brand-banner-info-subtitle-text mt-8 space-y-4 font-sans">
                {subtitles.map((subtitle, index) => 
                <div className="brand-info-text-box flex flex-col">
                    <span className="brand-info-point-item font-semibold text-black desktop:text-2xl laptop:text-2xl tablet:text-2xl">{subtitle}</span>
                    <span className="brand-info-description-text mt-1 font-light text-gray-500 desktop:text-2xl laptop:text-sm tablet:text-2xl">{descriptions[index]}</span>
                </div>
                )}
            </div> 
        </div>

        </motion.div>
        </div>
    </div>
    </section>
    );
};


export default BrandInfoBanner;